import Bowser from 'bowser';
export var Clients;
(function (Clients) {
    Clients["iOS"] = "ios";
    Clients["Kindle"] = "kindle";
    Clients["Android"] = "android";
    Clients["Html5"] = "html5";
})(Clients || (Clients = {}));
export class ClientDetector {
    static detectClient() {
        const info = ClientDetector.getInfo();
        if (info.os?.name?.match(/ios/i) ||
            info.platform?.model?.match(/ipad/i) ||
            info.platform?.model?.match(/iphone/i) ||
            // iPadOS 13.4 and later report as Mac. Detect touch screen devices
            (info.os?.name?.match(/mac/i) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2)) {
            return Clients.iOS;
        }
        if (info.platform?.vendor?.match(/amazon/i) || info.platform?.model?.match(/kindle/i)) {
            return Clients.Kindle;
        }
        if (info.os?.name?.match(/android/i) || info.browser?.name?.match(/android/i)) {
            return Clients.Android;
        }
        return Clients.Html5;
    }
    static getInfo() {
        var parsedResult = Bowser.parse(window.navigator.userAgent);
        return parsedResult;
    }
}
